<template>
    <GhostButton
        v-if="!isAdFreeActive && appStore.isPurchaseEnabled"
        :class="$style.button_override"
        interfaceTarget="no-ad-header-button"
        @click="adDisabledStore.openDisabledAdModal()"
    >
        <img
            :class="$style.icon"
            :src="NoAdImg"
            alt="No Ad"
        />
    </GhostButton>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import GhostButton from '@/components_new/Buttons/GhostButton.vue'
import { useAdDisabledStore } from '@/store/ad-disabled-store'
import { useAppStore } from '@/store/app-store'

import NoAdImg from './images/no-ad.webp?file'

const adDisabledStore = useAdDisabledStore()
const { isAdFreeActive } = storeToRefs(adDisabledStore)
const appStore = useAppStore()
</script>

<style module>
.button_override {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
}

.button_override::before {
    z-index: 1;
    box-shadow: inset 0 0 0 1px var(--white-25);
}

.icon {
    width: 48px;
    height: 48px;
}
</style>
